/**
 * 考试防作弊守卫：仅注册限制逻辑（右键、键盘黑名单、滚轮缩放、剪贴板、全屏退出后拉回等）。
 *
 * 全屏请在调用方与本模块导出的 API 一并使用（与 enableExamGuard 同文件导出）：
 * - `tryEnterFullscreenFromUserGesture()`：放在登录等按钮 handler 第一行，再写 await
 * - `requestFullscreen()`：考试页等与 `enableExamGuard()` 相邻调用
 */
import { exitFullscreenSafe } from "./fullscreen.js";
import { createFullscreenEscapeGuard } from "./fullscreenEscapeGuard.js";
import { createContextMenuGuard } from "./contextMenuGuard.js";
import { createKeyboardGuard } from "./keyboardGuard.js";
import { createWheelZoomGuard } from "./wheelZoomGuard.js";
import { createClipboardGuard } from "./clipboardGuard.js";

export {
  requestFullscreen,
  isFullscreen,
  exitFullscreenSafe,
  tryEnterFullscreenFromUserGesture,
} from "./fullscreen.js";

let active = false;
/** @type {Array<() => void>} */
let detachers = [];

function getActive() {
  return active;
}

export async function enableExamGuard() {
  await disableExamGuard();

  active = true;
  const ctx = { getActive };

  const guards = [
    createFullscreenEscapeGuard(ctx),
    createContextMenuGuard(ctx),
    createKeyboardGuard(ctx),
    createWheelZoomGuard(ctx),
    // createClipboardGuard(ctx),
  ];

  for (const g of guards) {
    g.attach();
    detachers.push(() => g.detach());
  }
}

export async function disableExamGuard() {
  if (!active && detachers.length === 0) {
    return;
  }

  active = false;
  for (const d of detachers) {
    d();
  }
  detachers = [];
  await exitFullscreenSafe();
}
